import React, { useEffect } from 'react';
import { Grid, Box, Typography, Divider } from '@mui/material';
import { CustomButton } from '../../shared';
import { useDispatch, useSelector } from 'react-redux';
import {getTriggerFields, updateFields} from '../../../redux/thunks/adminSettingsThunk';
import { TriggerFieldsSkeleton } from './skeleton';
import { actions } from '../../../redux/reducers/adminSettingsReducer';

const TriggerSettings = (props) => {
  const { } = props;
  const { company } = useSelector((state) => state.company);
  const dispatch = useDispatch()
  const { isLoading,triggerFields} = useSelector((state) => state.adminSettings)
  const {triggerFieldsData} = triggerFields

  const onChangeValue = (index, value) => {
    const updatedTriggerFieldsData = [...triggerFieldsData];
    updatedTriggerFieldsData[index] = {
      ...updatedTriggerFieldsData[index],
      triggers_map: { value },
    };
    dispatch(actions.updateTriggerFieldsDataAction(updatedTriggerFieldsData));
  }

  const save = () => {
    let data = [];
    triggerFieldsData.forEach(item => {
        if (item.triggers_map && item.triggers_map?.value) {
            data.push({ trigger_field_id: item.id, company_id: company.id, value: item.triggers_map.value })
        }
    });
    const res = dispatch(updateFields({companyId:company.id,
      data:{trigger_field: data } }));
}

  useEffect(()=>{
    if(company.id){
      dispatch(getTriggerFields({ companyId: company.id}))
    }
    
  },[company.id])
  return (
    <Grid container spacing={'24px'}>
      <Grid item xs={12}>
        <Grid container spacing={'24px'} className="flex-row">
          <Grid item xs={4}>
            <Box>
              <Typography className="text-md-medium gray-700">
                PFIQ Format
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box>
              <Typography className="text-md-medium gray-700">
                Client Format
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Divider className="border-1-gray mt-24px" />
      </Grid>

      {isLoading ? <TriggerFieldsSkeleton/> : triggerFieldsData?.map((row, index) => (<Grid item xs={12}>
        <Grid container spacing={'24px'} className="flex-row-center-start" key={row.id}>
          <Grid item xs={4}>
            <Box>
              <Typography className="text-sm-medium gray-700">
                {row.pfiq_format_field_name}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box className='max-width-70'>
              <input type="text" 
              className='custom-text-field text-md-regular' 
              placeholder={row.pfiq_format_field_default}
              value={row.triggers_map ? row.triggers_map.value : ''}
              onChange={e => {onChangeValue(index, e.target.value) }}
              />
            </Box>
          </Grid>
        </Grid>
        <Divider className="border-1-gray mt-24px" />
      </Grid>))}

      <Grid item xs={12}>
        <Box className="flex-row-end-center padding-tb-0-rl-32">
          <CustomButton
            title="Save"
            titleColor="#FFFFFF"
            buttonColor="#AD509E"
            handleClick={() => save()}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default TriggerSettings;